import { FaceShape, type FaceShape as FaceShapeValue } from '@optiflow/types';

/**
 * A generic silhouette per face shape.
 *
 * Drawings, never a customer. There is no photograph to show — none is captured and none is stored —
 * so these are illustrations of the category, the same for everybody, and the screen must never
 * suggest otherwise.
 *
 * They are symmetric about their own vertical axis, so nothing needs mirroring under RTL.
 */
const PATHS: Record<string, string> = {
  [FaceShape.OVAL]:
    'M50 6C74 6 86 30 86 62C86 96 70 124 50 124C30 124 14 96 14 62C14 30 26 6 50 6Z',
  [FaceShape.ROUND]:
    'M50 14C76 14 90 38 90 66C90 96 74 118 50 118C26 118 10 96 10 66C10 38 24 14 50 14Z',
  [FaceShape.SQUARE]:
    'M18 12H82C86 12 88 15 88 20V100C88 112 78 120 50 120C22 120 12 112 12 100V20C12 15 14 12 18 12Z',
  [FaceShape.OBLONG]:
    'M22 4H78C82 4 84 7 84 12V104C84 118 72 126 50 126C28 126 16 118 16 104V12C16 7 18 4 22 4Z',
  [FaceShape.HEART]:
    'M14 24C14 12 30 8 50 8C70 8 86 12 86 24L84 62C82 86 66 124 50 124C34 124 18 86 16 62Z',
  [FaceShape.DIAMOND]:
    'M50 6C62 6 76 34 88 64C76 96 62 124 50 124C38 124 24 96 12 64C24 34 38 6 50 6Z',
  [FaceShape.TRIANGLE]:
    'M34 8C60 8 66 10 68 22L82 92C86 112 72 122 50 122C28 122 14 112 18 92L32 22C34 10 32 8 34 8Z',
};

const OUTLINE = 'M50 8C70 8 84 30 84 60C84 94 68 122 50 122C32 122 16 94 16 60C16 30 30 8 50 8Z';

export function FaceShapeGlyph({
  shape,
  className,
}: {
  shape: FaceShapeValue;
  className?: string;
}) {
  const path = PATHS[shape];

  return (
    <svg viewBox="0 0 100 130" className={className} aria-hidden focusable="false">
      {path ? (
        <path
          d={path}
          fill="currentColor"
          fillOpacity="0.12"
          stroke="currentColor"
          strokeWidth="4"
        />
      ) : (
        <>
          <path
            d={OUTLINE}
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            strokeDasharray={shape === FaceShape.MIXED ? '8 6' : '3 7'}
          />
          {shape === FaceShape.MIXED ? (
            <text
              x="50"
              y="74"
              textAnchor="middle"
              fontSize="30"
              fill="currentColor"
              fontFamily="inherit"
            >
              +
            </text>
          ) : (
            <line x1="28" y1="36" x2="72" y2="94" stroke="currentColor" strokeWidth="4" />
          )}
        </>
      )}
    </svg>
  );
}
